import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorComponent } from './error.component';

@NgModule({
	imports: [
		CommonModule,
	],
	exports: [
		ErrorComponent,
	],
	providers: [
	],
	declarations: [
		ErrorComponent,
	],
})
export class ErrorModule { }
